export const config = {
  url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTgPOOPR6geRYi6mXv7J99oqfLs6Gr3MwI1dm1Pgyby4_FfjmJHdKbtd0R2r0Bb7m40ewIS2Ch6-S_U/pub?gid=944190457&single=true&output=csv",
  // title: "Virginia Tech Authors 2019-2022",
  // description: "A listing of all of the publications by Virginia Tech employees over the last 3 years",
  searchFields: [
    "First Name",
    "Last Name",
    "Editors",
    "Department",
    "College",
    "Title",
    "Publisher",
    "Year Published",
  ],
  headers: [
    {
      key: "First Name",
      value: "First Name",
    },
    {
      key: "Last Name",
      value: "Last Name",
    },
    {
      key: "Editors",
      value: "Co-Authors/Co-Editors",
    },
    {
      key: "Department",
      value: "Department",
    },
    {
      key: "College",
      value: "College",
    },
    {
      key: "Title",
      value: "Title",
    },
    {
      key: "Publisher",
      value: "Publisher",
    },
    {
      key: "Year Published",
      value: "Year Published",
    },
  ],
  link: false,
};
